import React, { useState } from "react"
import { useSelector } from "react-redux"
import { updateJobServiceTransition } from "requesters/jobServiceRequester"
import {
  OPERATION_MANAGER
} from "utils/constants"
import { roleCheck } from "utils/index"
import { getBaseUrl } from "../../../../reducers"
import ConfirmationModal from "../../modals/ConfirmationModal"
import CommentBox from "./CommentBox"

const SearchesWorkflow = ({
  jobService,
  systemRole,
  currentTeamRole,
  comment,
  setComment,
  reloadData
}) => {
  const {
    id, attributes: {
      workflow,
      cost,
      jobNo,
      forProjectX,
      projectXJobNo,
      jobTitle,
      docketResolved,
      willAutoGenerateFinalInvoice,
      autoInvoiceContactInfo
    }
  } = jobService
  const displayJobNo = forProjectX ? projectXJobNo : jobNo
  const btnOutline = `btn btn-outline-${willAutoGenerateFinalInvoice ? "danger" : "primary"}`
  const btnPrimary = `btn btn-${willAutoGenerateFinalInvoice ? "danger" : "primary"}`

  const baseUrl = useSelector(getBaseUrl)

  const [readyToSend, setReadyToSend] = useState(false)

  const sendToReadyToSend = (options = {}) => {
    let transition
    if (Number(cost) === 0 && docketResolved) {
      transition = "ready-to-send"
    } else {
      transition = "move-to-accounts"
    }

    updateJobServiceTransition(baseUrl, id, transition, comment, null, null, null, null, options)
      .then(res => {
        if (res.status === 200) {
          if (willAutoGenerateFinalInvoice && typeof reloadData === 'function') {
            reloadData();
          } else {
            window.location.reload();
          }
        }
      })
      // eslint-disable-next-line no-console
      .catch(err => console.log(err))
  }

  return (
    <div className="timeline-item mt-2">
      {roleCheck(systemRole, currentTeamRole, OPERATION_MANAGER) && (
        <div className="row mt-4">
          <CommentBox comment={comment} setComment={setComment} />
          <div className="mr-4 pt-2">Send to</div>
          <div className="mr-2">
            <button
              className={readyToSend ? btnPrimary : btnOutline}
              type="button"
              disabled={readyToSend}
              onClick={() => setReadyToSend(!readyToSend)}>
              Ready to Send
            </button>
            <ConfirmationModal
              jobNo={displayJobNo}
              jobTitle={jobTitle}
              show={readyToSend}
              resetState={() => setReadyToSend(false)}
              sendTo={(options) => sendToReadyToSend(options)}
              messageType="Client"
              danger={willAutoGenerateFinalInvoice}
              autoInvoiceContactInfo={autoInvoiceContactInfo}>
            </ConfirmationModal>
          </div>
        </div>
      )}
    </div>
  )
}
export default SearchesWorkflow
